import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const deleteCombinedCateringCart = async (payload) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.DELETE_COMBINED_CATERING_CART, payload);
    return response.data;
  } catch (error) {
    console.error("Error deleting combined catering cart:", error);
    throw error;
  }
};

